export class Certificate {
    previewTemplate: CertificateTemplate;
    printTemplate: CertificateTemplate;
    downloadTemplate: CertificateTemplate;
    contents: CertificateText[];
    downloadName: string;
    description: string;
}

export class CertificateTemplate {
    height: number;
    width: number;
    src: string;
}

export class CertificateText {
    xPercent: number;
    yPercent: number;
    widthPercent: number;
    heightPercent: number;
    font: string;
    color: string;
    text: string;
}